// environment.js
const validateEnvironment = () => {
    const requiredEnvVars = {
        REACT_APP_PROJECT_ID: process.env.REACT_APP_PROJECT_ID,
        REACT_APP_CONTRACT_ADDRESS: process.env.REACT_APP_CONTRACT_ADDRESS,
        REACT_APP_ALCHEMY_KEY: process.env.REACT_APP_ALCHEMY_KEY,
        REACT_APP_NETWORK_MODE: process.env.REACT_APP_NETWORK_MODE
    };

    const missingVars = Object.entries(requiredEnvVars)
        .filter(([_, value]) => !value)
        .map(([key]) => key);

    if (missingVars.length > 0) {
        throw new Error(
            `Missing required environment variables:\n${missingVars.join('\n')}\n` +
            'Please check your .env file and ensure all required variables are set.'
        );
    }

    const networkMode = process.env.REACT_APP_NETWORK_MODE.toLowerCase();
    if (!['mainnet', 'testnet'].includes(networkMode)) {
        throw new Error(
            `Invalid NETWORK_MODE: "${process.env.REACT_APP_NETWORK_MODE}"\n` +
            'REACT_APP_NETWORK_MODE must be either "mainnet" or "testnet"'
        );
    }

    // Validate address format
    const isValidAddress = /^0x[a-fA-F0-9]{40}$/.test(process.env.REACT_APP_CONTRACT_ADDRESS);
    if (!isValidAddress) {
        throw new Error(
            'Invalid CONTRACT_ADDRESS format. Must be a valid Ethereum address.'
        );
    }

    return {
        PROJECT_ID: process.env.REACT_APP_PROJECT_ID,
        CONTRACT_ADDRESS: process.env.REACT_APP_CONTRACT_ADDRESS,
        ALCHEMY_KEY: process.env.REACT_APP_ALCHEMY_KEY,
        NETWORK_MODE: networkMode
    };
};

// This will throw an error if validation fails
export const ENV = validateEnvironment();